import * as React from "react";
import { JSX } from "react/jsx-runtime";
const CalenderLeftIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={29}
    height={24}
    viewBox="0 0 29 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.2367 2.51094C21.4617 2.51094 21.6492 2.58594 21.8367 2.73594C22.1742 3.07344 22.1742 3.59844 21.8367 3.93594L13.9617 11.9984L21.8367 20.0234C22.1742 20.3609 22.1742 20.8859 21.8367 21.2234C21.4992 21.5609 20.9742 21.5609 20.6367 21.2234L12.1617 12.5984C11.8242 12.2609 11.8242 11.7359 12.1617 11.3984L20.6367 2.77344C20.7867 2.62344 21.0117 2.51094 21.2367 2.51094Z"
      fill="#004E9B"
    />
    <path
      d="M16.2367 2.51094C16.4617 2.51094 16.6492 2.58594 16.8367 2.73594C17.1742 3.07344 17.1742 3.59844 16.8367 3.93594L8.96172 11.9984L16.8367 20.0234C17.1742 20.3609 17.1742 20.8859 16.8367 21.2234C16.4992 21.5609 15.9742 21.5609 15.6367 21.2234L7.16172 12.5984C6.82422 12.2609 6.82422 11.7359 7.16172 11.3984L15.6367 2.77344C15.7867 2.62344 16.0117 2.51094 16.2367 2.51094Z"
      fill="#004E9B"
    />
  </svg>
);
export default CalenderLeftIcon;
